import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {Institution, InstitutionFiltering} from './institution.model';

export const loadInstitutions = createAction(
  '[Institution/API] Load Institutions',
  props<{ institutions: Institution[] }>()
);

export const addInstitution = createAction(
  '[Institution/API] Add Institution',
  props<{ institution: Institution }>()
);

export const upsertInstitution = createAction(
  '[Institution/API] Upsert Institution',
  props<{ institution: Institution }>()
);

export const addInstitutions = createAction(
  '[Institution/API] Add Institutions',
  props<{ institutions: Institution[] }>()
);

export const upsertInstitutions = createAction(
  '[Institution/API] Upsert Institutions',
  props<{ institutions: Institution[] }>()
);

export const updateInstitution = createAction(
  '[Institution/API] Update Institution',
  props<{ institution: Update<Institution> }>()
);

export const updateInstitutions = createAction(
  '[Institution/API] Update Institutions',
  props<{ institutions: Update<Institution>[] }>()
);

export const deleteInstitution = createAction(
  '[Institution/API] Delete Institution',
  props<{ id: string }>()
);

export const deleteInstitutions = createAction(
  '[Institution/API] Delete Institutions',
  props<{ ids: string[] }>()
);

export const clearInstitutions = createAction(
  '[Institution/API] Clear Institutions'
);

// CUSTOM ACTIONS
export const createInstitutionMutation = createAction(
  '[Institution/API] Create Institution',
  props<{ input: any }>()
);

export const updateInstitutionMutation = createAction(
  '[Institution/API] edit Institution',
  props<{ input: any }>()
);

export const loadHcmisInstitutionMutation = createAction(
  '[Institution/API] load hcmis Institution',
  props<{ input: { loadNewOnly: boolean, institutionsToUpdate: string[] } }>()
);

export const getAllInstitutions = createAction(
  '[Institution/API] Get All Institutions',
  props<{ filtering?: InstitutionFiltering, few?:boolean }>()
);
